import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import Notifications from './notifications'
import Profile from './profile.js'
import SaveBoundary from './save-boundary'

const PopOut = props => {
  const { name, rightToolbarState } = props,
    style = { top: props.top, left: '50px' }

  return (
    <div className='popout-container'
      style={style}>
      <div className='popout-container-pointer'>
      </div>
      {
        name === 'profile' ? <Profile hidePopout={props.hidePopout} /> :
          name === 'notifications' ? <Notifications hidePopout={props.hidePopout} /> :
            name === 'saveBoundary' ? <SaveBoundary hidePopout={props.hidePopout} /> : null
      }
    </div>
  )
}

const mapStateToProps = state => ({
  rightToolbarState: state.rightToolbarState
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(PopOut)
